import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M23.2402 41.87C23.2402 41.87 50.8702 27.42 52.2702 25.66C53.6702 23.9 54.6102 1 54.6102 1H76.6202C76.6202 1 77.5602 23.9 78.9603 25.66C80.3603 27.42 107.99 41.87 107.99 41.87C107.99 41.87 95.7402 56.92 65.6102 56.92C35.4802 56.92 23.2402 41.87 23.2402 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M9.52 47.5701C12.6 43.9401 47.16 26.7601 47.16 26.7601L52.29 17.1802L65.62 38.7302L78.95 17.1802L84.08 26.7601C84.08 26.7601 118.64 43.9301 121.72 47.5701C124.8 51.2001 129.24 73.5502 129.24 73.5502H2C2 73.5502 6.44 51.2001 9.52 47.5701Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M70.71 31.0602L79.99 45.1503L84.0699 26.7603"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M60.9704 31.0602L51.6904 45.1503L47.6104 26.7603"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M64.5003 37.7499C64.5003 37.7499 69.1203 44.3599 69.1203 52.4999C69.1203 60.6499 69.1203 67.91 69.1203 67.91H62.3203V34.22"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M65.6099 64.3201C66.2892 64.3201 66.8399 63.7694 66.8399 63.0901C66.8399 62.4108 66.2892 61.8601 65.6099 61.8601C64.9306 61.8601 64.3799 62.4108 64.3799 63.0901C64.3799 63.7694 64.9306 64.3201 65.6099 64.3201Z"
        fill={outline}
      />
      <path
        d="M65.6099 54.0901C66.2892 54.0901 66.8399 53.5395 66.8399 52.8602C66.8399 52.1809 66.2892 51.6301 65.6099 51.6301C64.9306 51.6301 64.3799 52.1809 64.3799 52.8602C64.3799 53.5395 64.9306 54.0901 65.6099 54.0901Z"
        fill={outline}
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6151"
          y1="32.0426"
          x2="65.6151"
          y2="21.20651"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
